import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class GetCommand extends AbstractConfDataCommand {
  reuse?: boolean;
  revise?: boolean;
}